import { SetupGuideLinkTrackingParams } from '../../connector/connector-form/interfaces/setupGuideLink';
import { SetupGuideCommService } from '../services/setup-guide-comm.service';
import useService from '../../injector/hooks/useService';

export default function useSetupGuideCommService() {
  const setupGuideCommService = useService(SetupGuideCommService);

  return {
    scrollSBSToSection: (
      link: string,
      trackingParams?: SetupGuideLinkTrackingParams,
      scrollOffset?: number,
      highlightTitle?: boolean,
    ) => setupGuideCommService.goToSection(link, trackingParams, scrollOffset, highlightTitle),
  };
}
